import apiService from "../api/api.service";
import { UpdateBranchDto, Store } from "../../types/shop.types";

class BranchService {
  private static instance: BranchService;

  public static getInstance(): BranchService {
    if (!BranchService.instance) {
      BranchService.instance = new BranchService();
    }
    return BranchService.instance;
  }

  public async updateBranchBySuperAdmin(id: number, data: Partial<UpdateBranchDto>): Promise<Store> {
    return apiService.patch(`/super-admin/branch/${id}`, data);
  }
}

const branchService = BranchService.getInstance();
export default branchService; 